const confirmPassword = [
    { type: 'required', message: 'Confirm password is required' },
    { type: 'areEqual', message: 'Password mismatch' }
]

export default { confirmPassword };